interface LemonadeProgressProps {
  currentStep: number;
  steps: string[];
}

export function LemonadeProgress({ currentStep, steps }: LemonadeProgressProps) {
  return (
    <div className="flex flex-col gap-0">
      {steps.map((step, index) => {
        const isActive = index === currentStep;
        const isCompleted = index < currentStep;
        
        return (
          <div key={step} className="flex items-start gap-3">
            {/* Dot and line */}
            <div className="flex flex-col items-center">
              <div
                className={`w-3 h-3 rounded-full border-2 transition-all ${
                  isActive
                    ? 'border-primary bg-primary'
                    : isCompleted
                    ? 'border-primary bg-primary'
                    : 'border-gray-300 bg-white'
                }`}
              />
              {index < steps.length - 1 && (
                <div
                  className={`w-0.5 h-8 transition-colors ${
                    isCompleted ? 'bg-primary' : 'bg-gray-200'
                  }`}
                />
              )}
            </div>
            
            {/* Label */}
            <span
              className={`text-sm pb-6 transition-colors ${
                isActive ? 'text-gray-700 font-medium' : 'text-gray-400'
              }`}
            >
              {step}
            </span>
          </div>
        );
      })}
    </div>
  );
}
